export { BannerPaidSocial } from "./BannerPaidSocial";
export type {
    BannerPaidSocialProps,
    BannerPaidSocialContent,
} from "./BannerPaidSocial.types";
